import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import _ from 'lodash';

export class OccupancySensingServerPlugin extends SmartenitPlugin {
  private active: boolean;

  public getReportableAttrs() {
    return ['Occupancy'];
  }

  // Methods
  public getStatusPayload(): any {
    return ['Occupancy'];
  }

  public isActive(): boolean {
    return  this.active || false;
  }

  public getConditionAttribute(): string {
    // return this by default but client can choose the attribute from JSON
    return 'OccupancyStatus';
  }

  public getConditionOptions(): any {
    return [
      {
        displayName: _.capitalize(
          _.get(
            this.translationService.getResource(),
            'AR.CONDITIONS_NL.IS_OCCUPIED',
            ''
          )
        ),
        name: 'is Occupied',
        value: 1
      },
      {
        displayName: _.capitalize(
          _.get(
            this.translationService.getResource(),
            'AR.CONDITIONS_NL.IS_UNOCCUPIED',
            ''
          )
        ),
        name: 'is Unoccupied',
        value: 0
      }
    ];
  }

  private parseStatus(status: number): any {
    // Bit 0 specifies the sensed occupancy as follows: 1 = occupied, 0 = unoccupied.
    return (status & 0x01) === 0x01;
  }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'Occupancy') {
      this.active = this.parseStatus(response.value);
      this._onUpdate.next({ occupancy: this.active });
    }
  }
}
